// @flow
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import type { State, Actions } from '../store';
import Login from '../components/Login';
import { actions as authActions } from '../store/auth';

const mapStateToProps = ({ authReducer, appReducer }: State) => ({
  isFetching: authReducer.isFetching,
  hasFetched: authReducer.hasFetched,
  session: authReducer.session,
  payload: authReducer.payload,

  error: authReducer.error,
  brand: appReducer.brand
});

const mapDispatchToProps = (dispatch: Dispatch<Actions>) => ({
  login: (email) => dispatch(authActions.login(email))
});

const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(Login);

export default LoginContainer;
